import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, noop as _$no, createUnknownComponentVNode as _$cc, extend as _$ex, EMPTY_OBJ as _$em } from 'intact-vue';
import { getRestProps } from '../utils';
import { Tooltip } from '../tooltip';
import { Icon } from '../icon';
import { Transition } from 'intact-vue';
import { makeItemStyles } from './styles';
import { context as ErrorContext } from './useError';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _$cn2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    label = _this$get.label,
    hideLabel = _this$get.hideLabel,
    htmlFor = _this$get.htmlFor,
    errorClassName = _this$get.errorClassName,
    rules = _this$get.rules,
    fluid = _this$get.fluid;
  var _this$dirty = this.dirty,
    isDirty = _this$dirty.isDirty.value,
    onChange = _this$dirty.onChange,
    onFocusout = _this$dirty.onFocusout;
  var _this$validateHook = this.validateHook,
    isValid = _this$validateHook.isValid.value,
    customErrorClassName = _this$validateHook.errorClassName.value;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-form-item"] = true, _classNameObj[k + "-invalid"] = isDirty && !isValid, _classNameObj[k + "-valid"] = isDirty && isValid, _classNameObj[className] = className, _classNameObj[k + "-fluid"] = fluid, _classNameObj[makeItemStyles(k)] = true, _classNameObj);
  var starOnRequired = this.form && this.form.get('starOnRequired');
  var labelWidth = this.form && this.form.get('labelWidth');
  var labelStyle;
  if (labelWidth != null) {
    if (/^\d+$/.test(labelWidth)) {
      labelStyle = {
        width: labelWidth + 'px'
      };
    } else {
      labelStyle = {
        width: labelWidth
      };
    }
  }
  var _this$error = this.error,
    ellipsis = _this$error.ellipsis,
    message = _this$error.message,
    errorRef = _this$error.errorRef;
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-change': onChange,
    'ev-focusout': onFocusout
  }), [!hideLabel ? _$ce(2, 'label', [starOnRequired && rules && rules.required ? _$ce(2, 'span', '*', 16, _$cn(k + "-form-star")) : undefined, (_$blocks['label'] = function ($super) {
    return label;
  }, __$blocks['label'] = function ($super, data) {
    var block = $blocks['label'];
    var callBlock = function callBlock() {
      return _$blocks['label'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['label'](_$no))], 0, _$cn(k + "-form-label"), {
    'htmlFor': htmlFor,
    'style': labelStyle
  }) : undefined, _$ce(2, 'div', [_$cc(ErrorContext.Provider, {
    'value': isDirty && !isValid,
    'children': (_$blocks['content'] = function ($super) {
      return children;
    }, __$blocks['content'] = function ($super, data) {
      var block = $blocks['content'];
      var callBlock = function callBlock() {
        return _$blocks['content'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['content'](_$no))
  }), _$cc(Transition, {
    'key': 'error',
    'name': 'k-fade',
    'children': isDirty && !isValid ? _$ce(2, 'div', [_$ce(2, 'div', message.value, 0, _$cn(k + "-error-message c-ellipsis"), null, null, errorRef), _$cc(Tooltip, {
      'hoverable': true,
      'position': 'bottom',
      'children': _$cc(Icon, {
        'className': _$cn("ion-ios-information-outline " + k + "-form-error-more"),
        'size': 'small',
        'color': 'inherit'
      }),
      '$blocks': function ($blocks) {
        var _$blocks = {},
          __$blocks = _$ex({}, $blocks);
        return (_$blocks['content'] = function ($super) {
          return message.value;
        }, __$blocks['content'] = function ($super, data) {
          var block = $blocks['content'];
          var callBlock = function callBlock() {
            return _$blocks['content'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }), __$blocks;
      }.call($this, _$em)
    })], 4, _$cn((_$cn2 = {}, _$cn2[k + "-form-error"] = true, _$cn2[errorClassName] = errorClassName, _$cn2[customErrorClassName] = customErrorClassName, _$cn2[k + "-ellipsis"] = ellipsis.value, _$cn2))) : undefined
  }, 'error')], 0, _$cn(k + "-form-content")), $blocks.append ? _$ce(2, 'div', (_$blocks['append'] = function ($super) {
    return null;
  }, __$blocks['append'] = function ($super, data) {
    var block = $blocks['append'];
    var callBlock = function callBlock() {
      return _$blocks['append'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['append'](_$no)), 0, _$cn(k + "-form-append")) : undefined]);
}
;